import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { WaterfallFilterStorage } from '@bingads-webui-campaign/filter-storage';
import { withPreference } from '@bingads-webui-react/preference-context';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const withWaterfallFilterStorage = (WrappedComponent) => {
  const HoC = (props) => {
    const ComponentWithStorage = ({ preferenceService, ...rest }) => {
      const waterfallFilterStorage = new WaterfallFilterStorage({
        preferenceService,
      });

      return (<WrappedComponent {...rest} waterfallFilterStorage={waterfallFilterStorage} />);
    };

    ComponentWithStorage.propTypes = {
      preferenceService: PropTypes.shape({
        setAtUserLevel: PropTypes.func.isRequired,
        findByNameAtUserLevel: PropTypes.func.isRequired,
      }).isRequired,
    };

    const ComponentWithPreference = withPreference(ComponentWithStorage);

    return (<ComponentWithPreference {...props} />);
  };

  HoC.displayName = `withWaterfallFilterStorage(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
